import React, { useState, useEffect, useRef } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import profile from "../images/profile.png";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import baseUrl from "../api/utils";
import axios from "axios";
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useNavigate } from "react-router-dom";
const AdminRegister = () => {
  const MySwal = withReactContent(Swal);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate=useNavigate();
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [formData, setFormData] = useState({
    username: "",
    psw: "",
    confirm_password: "",
    email: "",
    institution: "",
    dob: "",
    phone: "",
    gstinNumber: "",
    profile: null,
    countryCode: "",
    isActive: true,
    role: "ADMIN",
  });
  const [errors, setErrors] = useState({
    username: "",
    email: "",
    institution: "",
    dob: "",
    psw: "",
    gstinNumber: "",
    confirm_password: "",
    phone: "",
    fileInput: "",
    profile: "",
    otp: "",
  });

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const dobRef = useRef(null);
  const pswRef = useRef(null);
  const confirmPswRef = useRef(null);
  const gstinNumberRef = useRef(null);
  const phoneRef = useRef(null);
  const institutionRef = useRef(null);
  const [defaultCountry, setDefaultCountry] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

 const fetchUserCountryCode = async () => {
    try {
     
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
    
      const dialingCode = data.country_calling_code||"+1"
     
      setFormData((prevState) => ({
        ...prevState,
        countryCode: dialingCode,
      }));
      const countryCode = data.country_code.toUpperCase(); // Get the country code (e.g., "IN" for India, "US" for USA)
      setDefaultCountry(countryCode);
    } catch (error) {
      console.error("Error fetching country code: ", error);
    
      
    }
  };

  useEffect(() => {
    fetchUserCountryCode(); // Fetch user's country code on component mount
  }, []);

  const handlePhoneChange = (value) => {
    if (typeof value !== 'string') {
      return
    }
   
    setPhoneNumber(value);
    const phoneNumber = parsePhoneNumber(value);
    if (phoneNumber) {
      // Extract phone number without country code
      const phoneNumberWithoutCountryCode = phoneNumber.nationalNumber;
  
      setFormData((prevState) => ({
      ...prevState,
      phone:phoneNumberWithoutCountryCode ,
    }));
  }
    // Validate phone number
    if (value && isValidPhoneNumber(value)) {
      
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: '',
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: 'Enter a valid Phone number',
      }));
    }
  };
  const fetchCountryDialingCode = async (newCountryCode) => {
    try {
      if (!newCountryCode) {
       return;
      }
     
      // Fetch country data based on the new country code (e.g., "IN", "US")
      const response = await fetch(`https://restcountries.com/v3.1/alpha/${newCountryCode}`);
      const data = await response.json();
  
     
      // Extract the dialing code from the 'idd' object in the response
      const dialingCode = data[0]?.idd?.root + (data[0]?.idd?.suffixes?.[0] || "") || "+91";
  
      // Set the country dialing code in the formData
      setFormData((prevState) => ({
        ...prevState,
        countryCode: dialingCode,
      }));

     // const countryCode = data.country_code.toUpperCase(); // Get the country code (e.g., "IN" for India, "US" for USA)
      setDefaultCountry(newCountryCode);
    } catch (error) {
      console.error("Error fetching country dialing code: ", error);
      
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    switch (name) {
    
     
      case "email":
        error = /^[^\s@]+@[^\s@]+\.com$/.test(value)
          ? ""
          : "Please enter a valid email address";
        break;
      case "institution":
        error = value.length < 1 ? "Please enter a Company Name" : "";
        break;
      case "dob":
        const dobDate = new Date(value);
        const today = new Date();
        const maxDate = new Date(
          today.getFullYear() - 8,
          today.getMonth(),
          today.getDate()
        ); // Min age 8 years
        const minDate = new Date(
          today.getFullYear() - 100,
          today.getMonth(),
          today.getDate()
        ); // Max age 100 years
        error =
          dobDate <= maxDate && dobDate >= minDate
            ? ""
            : "Please enter a valid date of birth";
        break;

      case "psw":
        const passwordRegex =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(value)) {
        error =
          "Password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.";
      } else if (formData.confirm_password && formData.confirm_password !== value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          confirm_password: "Confirm password does not match the password.",
        }));
      }
      break;
      case "confirm_password":
        error = value !== formData.psw ? "Passwords do not match" : "";
        break;
     
      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
   if (file && file.size > 50 * 1024) {
  setErrors((prevErrors) => ({
    ...prevErrors,
    profile: 'Image size must be 50 KB or smaller',
  }));
  return;
}
setErrors((prevErrors) => ({
  ...prevErrors,
  profile: '',
}));
    convertImageToBase64(file)
      .then((base64Data) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          profile: file,
          base64Image: base64Data,
        }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          profile: "",
        }));
      })
      .catch((error) => {
        console.error("Error converting image to base64:", error);
      });
  };

  const handleSendOTP = async () => {
    if (!formData.email || errors.email) {
      setErrors(prev => ({
        ...prev,
        email: !formData.email ? "Email is required" : errors.email
      }));
      emailRef.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    setIsSendingOtp(true);
    try {
      // Clear OTP input and errors when resending
      setOtp("");
      setErrors(prev => ({ ...prev, otp: "" }));
      setOtpVerified(false);
      setOtpSent(true);
      
      const response = await axios.post(
        `${baseUrl}/auth/send-otp`,
        null,
        { 
          params: { 
            email: formData.email
          } 
        }
      );

      if (response.status === 200) {
        MySwal.fire({
          icon: "success",
          title: "OTP Sent!",
          text: "Please check your email for the OTP.",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data === "EMAIL") {
          setErrors(prev => ({
            ...prev,
            email: "This email is already registered"
          }));
        }
      } else {
        setErrors(prev => ({
          ...prev,
          email: "Failed to send OTP. Please try again."
        }));
      }
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      setErrors(prev => ({
        ...prev,
        otp: "OTP is required"
      }));
      return;
    }

    try {
      const response = await axios.post(
        `${baseUrl}/auth/verify-otp`,
        null,
        { params: { email: formData.email, otp } }
      );

      if (response.status === 200) {
        setOtpVerified(true);
        setErrors(prev => ({
          ...prev,
          otp: ""
        }));
   MySwal.fire({
        toast:true,
  position: 'top-end', 
  icon: 'success',
  title: 'Email verified successfully!',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});
      }
    } catch (error) {
      setErrors(prev => ({
        ...prev,
        otp: "Invalid or expired OTP"
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otpVerified) {
         MySwal.fire({
              toast:true,
        position: 'top-end', 
        icon: 'warning',
        title: 'Please Verify YOur Email First!',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });
      emailRef.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // Check if any required fields are empty or have errors
    let hasErrors = false;
    const requiredFields = [
      "institution",
      "email",
      "psw",
      "confirm_password",
      "phone",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].length === 0 || errors[field]) {
        hasErrors = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: !formData[field] ? "This field is required" : errors[field],
        }));
      }
    });
   

    if (hasErrors) {
      scrollToError(); // Scroll to the first error field
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("username", formData.username);
    formDataToSend.append("psw", formData.psw);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("institutionName", formData.institution);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("role", formData.role);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("isActive", formData.isActive);
    formDataToSend.append("profile", formData.profile);
    formDataToSend.append("gstinNumber", formData.gstinNumber);
    formDataToSend.append("countryCode", formData.countryCode);
    formDataToSend.append("otp", otp);

    try {
      const response = await axios.post(
        `${baseUrl}/admin/register`,
        formDataToSend
      );

      if (response.status === 200) {
        MySwal.fire({
          title: "Welcome to our Family!",
          text: "You have been registered successfully!",
          icon: "success",
          confirmButtonText: "Go to Login",
          showCancelButton: true,
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          } else {
            setFormData({
              username: "",
              psw: "",
              confirm_password: "",
              email: "",
              institution: "",
              dob: "",
              phone: "",
              gstinNumber: "",
              profile: null,
              isActive: true,
              countryCode:"",
              base64Image: null,
            });
            setPhoneNumber("");
          fetchUserCountryCode();
          setOtpSent(false);
          setOtpVerified(false);
          setOtp("");
          }
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const data = error.response.data;
        if (data === "EMAIL") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: "This email is already registered.",
          }));
        }  else if (data === "INSTITUTE") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            institution: "This institution is already registered.",
          }));
        } else if (data === "ADMIN") {
          MySwal.fire({
            title: "Error!",
            text: "Admin Already Registered.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        // MySwal.fire({
        //   title: "Error!",
        //   text: "An error occurred while registering. Please try again later.",
        //   icon: "error",
        //   confirmButtonText: "OK",
        // });
        throw error
      }
    }
  };

  const scrollToError = () => {
    if (errors.username) {
      nameRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.email) {
      emailRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.institution) {
      institutionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.dob) {
      dobRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.psw || errors.confirm_password) {
      pswRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.gstinNumber) {
      gstinNumberRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    } else if (errors.phone) {
      phoneRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }  
  };

  useEffect(() => {
    scrollToError();
  }, [errors]);

    // ... keep ALL imports, state, handlers, functions exactly as they are ...
  // ONLY the return( ) JSX below changes:

    return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0d3b52",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "24px 16px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "680px",
          background: "#ffffff",
          borderRadius: "14px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          overflow: "hidden",
        }}
      >
        {/* ── Brand header strip ── */}
        <div
          style={{
            background: "linear-gradient(90deg, #0d3b52 0%, #17a2b8 100%)",
            padding: "16px 28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "#fff" }}>InvoiceBill</div>
            <div style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.8)" }}>Create your company account</div>
          </div>
          <div
            style={{
              width: "52px",
              height: "52px",
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #fff",
              flexShrink: 0,
            }}
          >
            <img
              src={formData.base64Image ? formData.base64Image : profile}
              alt="Profile"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div style={{ padding: "20px 28px" }}>

          {/* ── Upload photo link (compact, right-aligned) ── */}
          <div style={{ textAlign: "right", marginBottom: "10px" }}>
            <label htmlFor="fileInput" style={{ fontSize: "0.78rem", fontWeight: 600, color: "#17a2b8", cursor: "pointer" }}>
              Upload Photo
            </label>
            {errors.profile && <div className="text-danger" style={{ fontSize: "0.72rem" }}>{errors.profile}</div>}
            <input type="file" name="fileInput" id="fileInput" style={{ display: "none" }} accept="image/*" onChange={handleFileChange} />
          </div>

          {/* ── Name + Company (side by side) ── */}
          <div className="row">
            <div className="col-sm-6 mb-2" ref={nameRef}>
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>Full Name</label>
              <input
                type="text"
                id="Name"
                value={formData.username}
                onChange={handleChange}
                name="username"
                className={`form-control form-control-sm mt-1 ${errors.username && "is-invalid"}`}
                placeholder="Full name"
                autoFocus
                required
              />
              <div className="invalid-feedback">{errors.username}</div>
            </div>

            <div className="col-sm-6 mb-2" ref={institutionRef}>
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
                Company Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                autoComplete="off"
                className={`form-control form-control-sm mt-1 ${errors.institution && "is-invalid"}`}
                name="institution"
                value={formData.institution}
                onChange={handleChange}
                placeholder="Company name"
                required
              />
              <div className="invalid-feedback">{errors.institution}</div>
            </div>
          </div>

          {/* ── Email + OTP ── */}
          <div className="mb-2" ref={emailRef}>
            <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
              Email <span className="text-danger">*</span>
            </label>
            <div className="d-flex mt-1">
              <input
                type="email"
                autoComplete="off"
                className={`form-control form-control-sm ${errors.email ? "is-invalid" : ""}`}
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@company.com"
                required
                disabled={otpVerified}
              />
                            <button
                type="button"
                className="btn btn-sm ms-2"
                style={{ background: "#0d3b52", color: "#fff", whiteSpace: "nowrap" }}
                onClick={handleSendOTP}
                disabled={!formData.email || errors.email || otpVerified || isSendingOtp}
              >
                {isSendingOtp ? "Sending..." : otpSent ? "Resend" : "Send OTP"}
              </button>
            </div>
            {errors.email && <div className="text-danger mt-1" style={{ fontSize: "0.75rem" }}>{errors.email}</div>}
            {otpVerified && <div style={{ color: "#28a745", fontSize: "0.75rem", marginTop: "3px" }}>✓ Email verified</div>}
          </div>

          {otpSent && !otpVerified && (
            <div className="mb-2">
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
                Enter OTP <span className="text-danger">*</span>
              </label>
              <div className="d-flex mt-1">
                <input
                  type="text"
                  className={`form-control form-control-sm ${errors.otp ? "is-invalid" : ""}`}
                  name="otp"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                    setOtp(value);
                    if (errors.otp) setErrors(prev => ({ ...prev, otp: "" }));
                  }}
                  placeholder="6-digit code"
                  maxLength="6"
                  required
                />
                <button
                  type="button"
                  className="btn btn-sm ms-2"
                  style={{ background: "#0d3b52", color: "#fff", whiteSpace: "nowrap" }}
                  onClick={handleVerifyOTP}
                  disabled={otp.length !== 6}
                >
                  Verify
                </button>
              </div>
              {errors.otp && <div className="text-danger mt-1" style={{ fontSize: "0.75rem" }}>{errors.otp}</div>}
            </div>
          )}

          {/* ── Password + Confirm (side by side) ── */}
          <div className="row">
            <div className="col-sm-6 mb-2">
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
                Password <span className="text-danger" ref={pswRef}>*</span>
              </label>
              <div className={`inputpsw form-control form-control-sm p-1 mt-1 ${errors.psw && "is-invalid"}`}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="psw"
                  className="form-control form-control-sm"
                  style={{ outline: "none" }}
                  value={formData.psw}
                  onChange={handleChange}
                  placeholder="Password"
                  id="pswinp"
                  autoComplete="new-password"
                  required
                />
                <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"} style={{ display: "flex", alignItems: "center" }} onClick={togglePasswordVisibility}></i>
              </div>
              <div className="invalid-feedback">{errors.psw}</div>
            </div>

            <div className="col-sm-6 mb-2">
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
                Confirm Password <span className="text-danger" ref={confirmPswRef}>*</span>
              </label>
              <div className={`inputpsw form-control form-control-sm p-1 mt-1 ${errors.confirm_password && "is-invalid"}`}>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  className="form-control form-control-sm"
                  value={formData.confirm_password}
                  style={{ outline: "none" }}
                  id="cpswinp"
                  onChange={handleChange}
                  autoComplete="new-password"
                  placeholder="Repeat password"
                  required
                />
                <i className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"} style={{ display: "flex", alignItems: "center" }} onClick={toggleConfirmPasswordVisibility}></i>
              </div>
              <div className="invalid-feedback">{errors.confirm_password}</div>
            </div>
          </div>

          {/* ── Phone + DOB (side by side) ── */}
          <div className="row">
            <div className="col-sm-6 mb-2" ref={phoneRef}>
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>
                Phone <span className="text-danger">*</span>
              </label>
              <div className="inputlikeeffect mt-1">
                <PhoneInput
                  placeholder="Phone number"
                  id="phone"
                  value={phoneNumber || ''}
                  onChange={handlePhoneChange}
                  className={`form-control form-control-sm ${errors.phone && "is-invalid"}`}
                  defaultCountry={defaultCountry}
                  international
                  countryCallingCodeEditable={true}
                  onCountryChange={fetchCountryDialingCode}
                />
                <div className="invalid-feedback">{errors.phone}</div>
              </div>
            </div>

            <div className="col-sm-6 mb-2">
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }} ref={dobRef}>Date of Birth</label>
              <input
                type="date"
                name="dob"
                className={`form-control form-control-sm mt-1 ${errors.dob && "is-invalid"}`}
                value={formData.dob}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">{errors.dob}</div>
            </div>
          </div>

          {/* ── GSTIN ── */}
          <div className="mb-3">
            <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }} ref={gstinNumberRef}>GSTIN Number</label>
            <input
              type="text"
              id="gstinNumber"
              value={formData.gstinNumber}
              onChange={handleChange}
              name="gstinNumber"
              className={`form-control form-control-sm mt-1 ${errors.gstinNumber && "is-invalid"}`}
              placeholder="Optional"
              required
            />
            <div className="invalid-feedback">{errors.gstinNumber}</div>
          </div>

          {/* ── Buttons ── */}
          <div className="d-flex justify-content-between align-items-center">
            <button className="btn btn-sm btn-secondary" type="button" onClick={() => navigate(-1)}>
              Cancel
            </button>
                       <button
              className="btn btn-sm"
              style={{ background: "#0d3b52", color: "#fff", padding: "7px 26px", fontWeight: 600 }}
              onClick={handleSubmit}
            >
              Create Account
            </button>
          </div>

          <div className="text-center mt-2">
            <a href="/login" style={{ fontSize: "0.8rem", color: "#0d3b52" }}>
              Already have an account? <strong>Login</strong>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminRegister;